import type { FC } from 'react';

import { useUserList } from '../../model';
import { UserCard } from '../card';
import * as st from './styles.module.scss';

export const UserList: FC = () => {
	const { list } = useUserList();
	return (
		<div className={st.list}>
			<div className={st.scroller}>
				{list.map((user, id) => (
					<>
						<UserCard user={user} key={id} />
					</>
				))}
			</div>
		</div>
	);
};
